import { Form, Row } from 'react-bootstrap';

export function StatisticsOffersFilters({ handleChanges }: any) {
    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Lowest price from"
                        className="autocomplete-input"
                        name="minPriceFrom"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Lowest price to"
                        className="autocomplete-input"
                        name="minPriceTo"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Highest price from"
                        className="autocomplete-input"
                        name="maxPriceFrom"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Highest price to"
                        className="autocomplete-input"
                        name="maxPriceTo"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="AVG price from"
                        className="autocomplete-input"
                        name="averagePriceFrom"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="AVG price to"
                        className="autocomplete-input"
                        name="averagePriceTo"
                        onChange={handleChanges}
                    />
                </div>
            </Row>
        </Form>
    );
}
